module.exports = __webpack_public_path__ + "static/tooltip1_8-ee0d436312f0eadb4738e3d7022fa851.png";